import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, from, of } from 'rxjs';
import * as _firebase from 'firebase/app';
const firebase = _firebase;
import 'firebase/auth';
import { switchMap, tap, map, share, first, delay } from 'rxjs/operators';
import { get } from 'lodash';

export type loginType = 'phonenumber' | 'github';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  windowRef: any;
  _idTokenResult: firebase.auth.IdTokenResult;
  user = this.fbAuth.user.pipe(share());
  idTokenResult = this.fbAuth.idTokenResult.pipe(
    tap(idTokenResult => (this._idTokenResult = idTokenResult)),
    share()
  );
  private signedIn: boolean = undefined;
  constructor(private fbAuth: AngularFireAuth) {
    this.idTokenResult.subscribe();
    this.fbAuth.auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
    this.user.subscribe(user => (this.signedIn = user ? true : false));
  }
  get uid(): string {
    return this.currentUser ? this.currentUser.uid : undefined;
  }
  get as(): string {
    return get(this._idTokenResult, ['claims', 'as']) || this.uid;
  }
  get tags(): string[] {
    return (get(this._idTokenResult, ['claims', 'tags']) || '').split(',').filter(v=>v).map(t=>decodeURIComponent(t));
  }

  get currentUser(): firebase.User {
    return this.fbAuth.auth.currentUser;
  }
  getIdTokenResult(): Promise<firebase.auth.IdTokenResult> {
    if (!this.signedIn) {
      return this.user
        .pipe(
          first(),
          switchMap(user => {
            if (user) return this.fbAuth.auth.currentUser.getIdTokenResult();
            else return of(null);
          }),
        )
        .toPromise();
    }
    else return this.fbAuth.auth.currentUser.getIdTokenResult();
  }
  upgradeToken(survey_id:string, as?:string, tags?:string[]): Observable<firebase.auth.IdTokenResult> {
    return from(
      firebase.functions().httpsCallable('tokenUpgrade')({ survey_id, as, tags })
    ).pipe(
      map(response => response.data as string),
      switchMap(token => this.signInWithCustomToken(token)),
      delay(0), // wait until the watcher picks up and update auth state in memory
    );
  }
  signInWithCustomToken(
    token: string
  ): Observable<firebase.auth.IdTokenResult> {
    return from(this.fbAuth.auth.signInWithCustomToken(token)).pipe(
      switchMap(userCredential => userCredential.user.getIdTokenResult())
    );
  }
  logout(): Promise<void> {
    return this.fbAuth.auth.signOut();
  }
  getSurveyScope(
    scopeType: 'reply' | 'replies' | 'compose' | 'view'
  ): boolean | string {
    return get(this._idTokenResult, ['claims', scopeType]);
  }
}
